export default "__VITE_ASSET__6bff6688__"